import { Question } from './question';
import { Trigger } from './trigger';

export class QuestionSelect extends Question{
  
  options:Array<QuestionSelectOption> = [];
  isMultiSelect: boolean;
  
  constructor(object = null){
    super();
    this.type = 'QuestionSelect';
    this.typeText = "選択肢";
    this.isMultiSelect = false;

    if(object){
      this.set(object);
    }
  };

  set(object){
    super.set(object);

    this.isMultiSelect = (object.isMultiSelect) ? true : false;
    
    if(object.options && object.options.length > 0){
      for(let optionObject of object.options){
        let option:QuestionSelectOption = new QuestionSelectOption(optionObject);
        option.parentQuestionSelect = this;
        this.options.push(option);
      }
    }
  }

  static test(){
    const object = {
      hash:"xxxxxxxx",
      title:"業種を選択してください",
      options:[
        {
          "key": "zzz1",
          "value": "製造業",
        },
        {
          "key": "zzz2",
          "value": "保険・金融",
        },
        {
          "key": "zzz3",
          "value": "サービス業",
        },
      ],
    };
    return object;
  }

  // clone():QuestionSelect{
  //   const content = new QuestionSelect();
  //   content.type = this.type;
  //   content.typeText = this.typeText;
  //   content.title = this.title;
  //   content.value = this.value;
  //   content.required = this.required;
  //   content.options = [];
  //   for(const options of this.options){
  //     const newOption = new QuestionSelectOption();
  //     newOption.type = options.type;
  //     newOption.key = options.key;
  //     newOption.value = options.value;
  //     content.options.push(newOption);
  //   }
  //   return content;
  // }
}

export class QuestionSelectOption{
  type:string = "QuestionSelectOption";
  key:string;
  value:any = "";
  trigger:Trigger;
  parentQuestionSelect:QuestionSelect;

  constructor(object = null){
    this.key = this.generateHash();

    if(object){
      this.set(object);
    }
  }

  set(object){
    if(object.key){
      this.key = object.key;
    }
    if(object.value){
      this.value = object.value;
    }
    if(object.trigger){
      this.trigger = new Trigger(object.trigger);
      this.trigger.baseContent = this;
    }
  }

  isMainContent(){
    return false;
  }
  isSubContent(){
    return false;
  }

  generateHash(){
    // 生成する文字列の長さ
    var l = 12;

    // 生成する文字列に含める文字セット
    var c = "abcdefghijklmnopqrstuvwxyz0123456789";

    var cl = c.length;
    var r = "";
    for(var i=0; i<l; i++){
      r += c[Math.floor(Math.random()*cl)];
    }
    return r;
  }
}
  
  